import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  public assetsUrl : string = '';
  public lnfServiceDeskemail : string = '';

  constructor() {
    // Blank constructor
   }

  ngOnInit(): void {
    this.assetsUrl = environment.assetsUrl;
    this.lnfServiceDeskemail = environment.lnfServiceDeskemail;
  }

}
